import { render, staticRenderFns } from "./UserAddNoteItem.vue?vue&type=template&id=f50fac42&"
import script from "./UserAddNoteItem.vue?vue&type=script&lang=js&"
export * from "./UserAddNoteItem.vue?vue&type=script&lang=js&"
import style0 from "./UserAddNoteItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports